import {
  OrganizationsDTO,
  OrganizationStatus
} from '../types/Organization.types';
import API from './ApiBase';

/**
 * Organizations visible to the caller. A superadmin gets all of them; an admin
 * gets their own as a single-element list; a USER gets 403
 * CROSS_ORG_ACCESS_DENIED, so only call this for a superadmin.
 *
 * Defaults to status='ACTIVE': a PENDING_ADMIN org has no accepted admin yet,
 * and the invite path rejects it (ORG_NOT_ACTIVE), so the pickers fed from here
 * must not offer one. Pass a different status only when pending orgs are wanted.
 */
export async function getOrganizations(
  limit = 100,
  offset = 0,
  q?: string,
  status: OrganizationStatus = 'ACTIVE'
) {
  return await API.get<OrganizationsDTO>('/organizations', {
    params: { limit, offset, status, ...(q ? { q } : {}) }
  });
}
